export {
	Elements,
	CardElement,
	useStripe,
	useElements,
} from '@stripe/react-stripe-js'

import { loadStripe as load, StripeElementsOptions } from '@stripe/stripe-js'

import { API_KEY_STRIPE } from 'external/environment'

export const stripeOptions:StripeElementsOptions = {
    appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: '#0570de',
      colorBackground: '#ffffff',
      colorText: '#30313d',
      colorDanger: '#df1b41',
      fontFamily: 'Ideal Sans, system-ui, sans-serif',
      spacingUnit: '2px',
      borderRadius: '4px',
    }
  }
}

export const loadStripe = (key?: any) => load(key || API_KEY_STRIPE)